import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/filtered/FilteredDateHistoryFilter/.eu';
import Kr from '@di-shared/features/history/filtered/FilteredDateHistoryFilter/.kr';

interface FilteredDateHistoryFilterProps {
  vin: string;
}

export default function FilteredDateHistoryFilter({vin}: FilteredDateHistoryFilterProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
